import { StrapiAsset } from '../types/strapi.type';

export const getStrapiUrl = (image: StrapiAsset) => {
  return image.url || '';
};
